import styled from '@emotion/styled';
import {
  Palette,
  Box,
  BoxProps,
  Text,
  Button,
  GridCard,
  TextLink,
} from '@updater/ui-uds';

export const GridCardColumn = styled(GridCard)`
  display: flex;
  flex-direction: column;
`;

export const GridCardColumnTop = styled(Box)<BoxProps>`
  background-color: ${Palette.white};
  width: 100%;
  padding-bottom: ${(props) => props.theme.space.m}px;
  padding-top: ${(props) => props.theme.space.m}px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
`;

export const GridCardLogo = styled(Box)`
  width: 122px;
  height: ${(props) => props.theme.space.xl}px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const GridCardColumnBottom = styled(Box)<BoxProps>`
  background-color: ${Palette.gray96};
  width: 100%;
  height: 100%;
  padding: ${(props) => props.theme.space.m}px;
  display: flex;
  flex-direction: row;
`;

export const GridCardSubTitle = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
`;

export const GridCardPhoneNumber = styled(TextLink)``;

export const GridCardColumnSuccess = styled(Box)<BoxProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const GridCardColumnSuccessIcon = styled(Box)<BoxProps>`
  width: ${(props) => props.theme.space.m}px;
  height: ${(props) => props.theme.space.m}px;
  margin-right: ${(props) => props.theme.space.xs}px;
`;

export const GridCardCTA = styled(Box)`
  margin-top: auto;
`;

export const GridCardColumnButton = styled(Button)`
  /* margin-top: ${(props) => props.theme.space.s}px; */
  min-width: 140px;
`;

export const GridCardLinkWrapper = styled(Box)`
  a {
    display: grid;
    padding: ${(props) => props.theme.space.xs}px 0;
  }
`;
